import http from 'utils/http';
import { getCountryUrl, getStatesUrl } from './apiUrl';

export async function getCountries(): Promise<{ value: string | number; label: string }[]> {
  const data = await http.get(getCountryUrl());
  return Object.keys(data).map((key) => ({
    value: key,
    label: data[key]
  }));
}

export async function getStates(countryCode: string): Promise<{ value: string | number; label: string }[]> {
  const data = await http.get(getStatesUrl(countryCode));
  return Object.keys(data).map((key) => ({
    value: key,
    label: data[key]
  }));
}
